import React from 'react';

import Hero from './Hero';
import Services from './Services';
import About from './About';
import Map from './Map';
import Contact from './Contact';

function Home() {
  return (
    <>

        <title>TKS Courier & Cargo | Reliable Shipping Services in Singapore</title>
        <meta name="description" content="Professional courier and cargo services in Singapore. Express delivery, international shipping, freight forwarding, and logistics solutions. Same-day delivery available." />
        <meta name="keywords" content="courier Singapore, cargo shipping, express delivery, international shipping, freight forwarding, logistics Singapore, same-day delivery" />
        <link rel="canonical" href="https://tkscourier.com/" />
        <meta property="og:title" content="TKS Courier & Cargo | Reliable Shipping Services in Singapore" />
        <meta property="og:description" content="Professional courier and cargo services in Singapore. Express delivery, international shipping, and logistics solutions." />
        <meta property="og:url" content="https://tkscourier.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="TKS Courier & Cargo | Reliable Shipping Services in Singapore" />
        <meta name="twitter:description" content="Professional courier and cargo services in Singapore." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "TKS Courier & Cargo",
            "description": "Professional courier and cargo services in Singapore",
            "url": "https://tkscourier.com",
            "logo": "https://tkscourier.com/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+65-1234-5678",
              "contactType": "Customer Service",
              "availableLanguage": "English"
            },
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "SG",
              "addressLocality": "Singapore"
            },
            "sameAs": [
              "https://www.facebook.com/tkscourier",
              "https://www.linkedin.com/company/tks-courier-cargo"
            ]
          })}
        </script>

      <Hero />
      <Services />
      <About />
      <Map />
      <Contact />
    </>
  );
}

export default Home;